// Failed panel changes in the admin console (TOM-1028): the wire shape of
// /v1/admin/neo/panel-change-failures and how it is shown. Pure, so it is
// tested under Node. Value-free: codes, counts and boat names, so no access
// reason is asked.

export interface PanelChangeFailureDay {
  day: string;
  failures: number;
  neoFailures: number;
  failedTurns: number;
  ownerFailures: number;
  panelChangeTurns: number;
  ratePer100: number | null;
}

export interface PanelChangeFailureRow {
  id: string;
  createdAt: string;
  code: string;
  writer: 'owner' | 'neo' | 'system';
  turnRef: string | null;
  boatId: string | null;
  boatName: string | null;
  receiptStatus: string | null;
  boardSlug: string | null;
  itemId: string | null;
  source: string;
  errorName: string | null;
}

export interface PanelChangeFailureSummary {
  days: number;
  failures: number;
  panelChangeTurns: number;
  failedTurns: number;
  ratePer100: number | null;
  daily: PanelChangeFailureDay[];
  topCodes: Array<{ code: string; count: number }>;
  recent: PanelChangeFailureRow[];
}

export function panelChangeFailuresPath(days = 14, boatId?: string): string {
  const q = new URLSearchParams({ days: String(days) });
  if (boatId !== undefined && boatId.trim().length > 0) q.set('boatId', boatId.trim());
  return `/v1/admin/neo/panel-change-failures?${q.toString()}`;
}

/** A rate per 100 panel-change turns, or a dash with no turn. */
export function rateLabel(rate: number | null): string {
  return rate === null ? '—' : `${rate.toFixed(1)}`;
}

/** The headline over the window. */
export function panelChangeFailuresSummary(s: PanelChangeFailureSummary): string {
  const window = `the last ${s.days} ${s.days === 1 ? 'day' : 'days'}`;
  if (s.failures === 0) return `No failed panel changes in ${window}.`;
  const rows = `${s.failures} failed panel ${s.failures === 1 ? 'change' : 'changes'} in ${window}`;
  if (s.ratePer100 === null) return `${rows}.`;
  return `${rows}: ${s.failedTurns} of ${s.panelChangeTurns} Neo panel-change ${
    s.panelChangeTurns === 1 ? 'turn' : 'turns'
  } failed, ${rateLabel(s.ratePer100)} per 100.`;
}
